class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    var animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      animations.forEach((animation) => animation.play());
    } else {
      animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Hover open/close — desktop only, uses CSS class instead of details[open]
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      // Prevent click from toggling details[open] on desktop
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', function(e) {
        e.preventDefault();
      });
    }
  }

  onMouseEnter() {
    clearTimeout(this._leaveTimer);
    // Close any other open header menus first
    document.querySelectorAll('header-menu').forEach(function(menu) {
      if (menu !== this) {
        menu.classList.remove('se-hover-open');
      }
    }.bind(this));
    this.classList.add('se-hover-open');

    // Toggle wrapper class
    if (this.header) {
      this.header.classList.add('se-dropdown-active');
    }
  }

  onMouseLeave() {
    var self = this;
    this._leaveTimer = setTimeout(function() {
      self.classList.remove('se-hover-open');
      // Check if any menu is still hovered
      var anyOpen = document.querySelector('header-menu.se-hover-open');
      if (!anyOpen && self.header) {
        self.header.classList.remove('se-dropdown-active');
      }
    }, 200);
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
